/* NITIDUS — theme behaviour. No dependencies. */
(function () {
  'use strict';
  var N = window.Nitidus || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = N.moneyFormat || '${{amount}}';
    cents = Number(cents) || 0;
    function withDelim(n, dp, t, d) {
      var parts = (n / 100).toFixed(dp).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (parts[1] ? d + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return withDelim(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelim(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelim(cents, 2, "'", '.');
        default: return withDelim(cents, 2, ',', '.');
      }
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Reveal on scroll ---------- */
  var revealIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
  }, { threshold: .18, rootMargin: '0px 0px -6% 0px' }) : null;
  $$('[data-reveal], .reveal').forEach(function (el) { revealIO ? revealIO.observe(el) : el.classList.add('is-in'); });

  /* Animations that loop only while visible (step illustrations) */
  var playIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.classList.toggle('is-playing', e.isIntersecting); });
  }, { threshold: .1 }) : null;
  $$('.step-art, .shield-draw, .pet-art').forEach(function (el) { playIO ? playIO.observe(el) : el.classList.add('is-playing'); });

  /* ---------- Lazy videos ---------- */
  var vidIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (v.hasAttribute('data-lazy-video')) {
          $$('source[data-src]', v).forEach(function (s) { s.src = s.dataset.src; s.removeAttribute('data-src'); });
          v.removeAttribute('data-lazy-video'); v.load();
        }
        if (!N.reducedMotion) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (!v.paused) v.pause();
    });
  }, { rootMargin: '200px' }) : null;
  $$('video.nit-video').forEach(function (v) {
    if (N.reducedMotion) { v.removeAttribute('autoplay'); v.controls = true; }
    if (vidIO) vidIO.observe(v);
  });

  /* ---------- Header ---------- */
  var header = $('[data-header]'), swipeBar = $('[data-scroll-swipe]');
  if (header) {
    var lastY = 0, ticking = false;
    function onScroll() {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 12);
      if (swipeBar) { var max = document.documentElement.scrollHeight - window.innerHeight; swipeBar.style.setProperty('--p', max > 0 ? Math.min(1, y / max).toFixed(4) : 0); }
      if (window.innerWidth >= 990) header.classList.toggle('is-hidden', y > lastY && y > 420 && !document.body.classList.contains('menu-open'));
      else header.classList.remove('is-hidden');
      lastY = y; ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
    onScroll();
  }

  /* ---------- Anchor links that point at sections on the home page ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    if (!document.getElementById(id)) { e.preventDefault(); window.location.href = (N.routes.root || '/') + '#' + id; }
  });

  /* ---------- Mobile menu ---------- */
  var menu = $('[data-mobile-menu]'), menuBtn = $('[data-menu-toggle]');
  function trapFocus(container, e) {
    var f = $$('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', container).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }
  function setMenu(open) {
    if (!menu) return;
    if (open) { menu.hidden = false; requestAnimationFrame(function () { menu.classList.add('is-open'); }); var first = $('a, button', menu); first && first.focus(); }
    else { menu.classList.remove('is-open'); setTimeout(function () { menu.hidden = true; }, 320); menuBtn && menuBtn.focus(); }
    document.body.classList.toggle('menu-open', open);
    menuBtn && menuBtn.setAttribute('aria-expanded', String(open));
  }
  menuBtn && menuBtn.addEventListener('click', function () { setMenu(true); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });
  menu && menu.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); if (e.key === 'Tab') trapFocus(menu, e); });

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-cart-drawer]');
  var cartState = null;
  try { cartState = JSON.parse(($('#CartInitial') || {}).textContent || 'null'); } catch (_) {}
  var lastFocus = null;

  function renderCart(cart) {
    cartState = cart;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.classList.toggle('is-empty', cart.item_count === 0); });
    if (!drawer) return;
    var list = $('[data-cart-items]', drawer), foot = $('[data-cart-foot]', drawer);
    $('[data-cart-subtotal]', drawer).textContent = formatMoney(cart.total_price);
    if (!cart.items.length) {
      list.innerHTML = ($('#CartEmptyTpl') || { innerHTML: '' }).innerHTML; foot.hidden = true;
      $$('[data-cart-close]', list).forEach(function (b) { b.addEventListener('click', closeCart); });
      return;
    }
    foot.hidden = false;
    list.innerHTML = '<ul class="cart-lines" role="list">' + cart.items.map(function (it, i) {
      var img = it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')) + '" alt="" width="72" height="72" loading="lazy">' : (N.fallbackImg ? '<img class="cart-line__fallback" src="' + esc(N.fallbackImg) + '" alt="" width="72" height="72">' : '');
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<p class="small muted">' + esc(it.variant_title) + '</p>' : '';
      return '<li class="cart-line" data-line="' + (i + 1) + '">' +
        '<div class="cart-line__img">' + img + '</div>' +
        '<div class="cart-line__info"><p class="cart-line__title">' + esc(it.product_title) + '</p>' + variant +
        '<div class="qty" role="group" aria-label="Quantity">' +
          '<button type="button" class="qty__btn" data-qty="-1" aria-label="Decrease quantity">−</button>' +
          '<span class="qty__val tabular" aria-live="polite">' + it.quantity + '</span>' +
          '<button type="button" class="qty__btn" data-qty="1" aria-label="Increase quantity">+</button>' +
        '</div></div>' +
        '<div class="cart-line__end"><p class="cart-line__price tabular">' + formatMoney(it.final_line_price) + '</p>' +
        '<button type="button" class="cart-line__remove small" data-remove>Remove</button></div></li>';
    }).join('') + '</ul>';
  }

  function changeLine(line, qty) {
    drawer && drawer.classList.add('is-busy');
    return fetch(N.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart)
      .finally(function () { drawer && drawer.classList.remove('is-busy'); });
  }

  function openCart() {
    if (!drawer) { window.location.href = N.routes.cartUrl; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); $('.drawer__panel', drawer).focus(); });
    document.body.classList.add('drawer-open');
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    setTimeout(function () { drawer.hidden = true; }, 360);
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  if (drawer) {
    if (cartState) renderCart(cartState);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
      var li = e.target.closest('[data-line]'); if (!li) return;
      var line = +li.dataset.line, item = cartState.items[line - 1];
      if (e.target.closest('[data-remove]')) changeLine(line, 0);
      var q = e.target.closest('[data-qty]'); if (q) changeLine(line, Math.max(0, item.quantity + +q.dataset.qty));
    });
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); if (e.key === 'Tab') trapFocus(drawer, e); });
    if (document.documentElement.dataset.cartDrawer !== 'off') $$('[data-cart-toggle]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  }

  /* ---------- Pack picker + add to cart ---------- */
  $$('form[data-product-form]').forEach(function (form) {
    var btn = $('[data-add-button]', form), priceEl = $('[data-add-price]', form), err = $('[data-add-error]', form);
    form.addEventListener('change', function (e) {
      if (e.target.name === 'id' && priceEl) {
        priceEl.textContent = e.target.dataset.price;
        priceEl.classList.remove('is-bump'); void priceEl.offsetWidth; priceEl.classList.add('is-bump');
      }
    });
    form.addEventListener('submit', function (e) {
      if (!drawer || !window.fetch || document.documentElement.dataset.cartDrawer === 'off') return;
      e.preventDefault();
      var checked = $('input[name="id"]:checked', form) || $('input[name="id"]', form);
      if (!checked) return;
      btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); if (err) err.hidden = true;
      fetch(N.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +checked.value, quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetch(N.routes.cart, { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); if (N.flyToCart) N.flyToCart(btn, openCart); else openCart(); document.dispatchEvent(new CustomEvent('nit:added')); })
        .catch(function (j) { if (err) { err.textContent = (j && (j.description || j.message)) || 'Something went wrong. Please try again.'; err.hidden = false; } })
        .finally(function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); });
    });
  });

  /* ---------- Sticky mobile buy bar ---------- */
  var sticky = $('[data-sticky-cta]');
  if (sticky && 'IntersectionObserver' in window) {
    var heroEl = $('[data-hero]') || $('.pdp__info .bundle-actions');
    var buyEl = document.getElementById('buy');
    var footEl = $('.site-footer');
    var state = { hero: true, buy: false, foot: false };
    function upd() {
      var show = !state.hero && !state.buy && !state.foot;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      $$('a', sticky).forEach(function (a) { a.tabIndex = show ? 0 : -1; });
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.target === heroEl) state.hero = e.isIntersecting;
        if (e.target === buyEl) state.buy = e.isIntersecting;
        if (e.target === footEl) state.foot = e.isIntersecting;
      });
      upd();
    });
    [heroEl, buyEl, footEl].forEach(function (el) { el && io.observe(el); });
    if (!heroEl) state.hero = false;
  }

  /* ---------- Try-it interactive demo ---------- */
  $$('[data-tryit]').forEach(function (wrap) {
    var demoEl = $('nit-demo', wrap), fill = $('[data-tryit-fill]', wrap), pct = $('[data-tryit-pct]', wrap);
    var done = $('[data-tryit-done]', wrap), arm = $('[data-tryit-arm]', wrap), hint = $('[data-tryit-hint]', wrap);
    var coarse = window.matchMedia('(pointer: coarse)').matches, finished = false;
    if (coarse && hint) hint.textContent = hint.dataset.touch;
    if (!coarse) wrap.classList.add('is-armed');
    arm && arm.addEventListener('click', function () { wrap.classList.add('is-armed'); });
    demoEl.addEventListener('nit:progress', function (e) {
      var p = Math.min(100, Math.round(e.detail * 100 / .92));
      fill.style.transform = 'scaleX(' + p / 100 + ')'; pct.textContent = p + '%';
      if (p >= 100 && !finished) {
        finished = true;
        setTimeout(function () { demoEl.demo && demoEl.demo.finish(); }, 250);
        setTimeout(function () { done.hidden = false; wrap.classList.add('is-done'); }, 900);
      }
    });
    $('[data-tryit-reset]', wrap).addEventListener('click', function () {
      finished = false; done.hidden = true; wrap.classList.remove('is-done');
      demoEl.demo && demoEl.demo.reset();
    });
    if (N.reducedMotion) { wrap.classList.add('is-armed'); }
  });

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var track = $('[data-gallery-track]', g), thumbs = $$('[data-thumb]', g), slides = $$('[data-slide]', g);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.dataset.thumb; track.scrollTo({ left: slides[i].offsetLeft, behavior: N.reducedMotion ? 'auto' : 'smooth' });
      });
    });
    if (thumbs.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { var i = slides.indexOf(e.target); thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', String(k === i)); }); } });
      }, { root: track, threshold: .6 });
      slides.forEach(function (s) { io.observe(s); });
    }
    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault(); track.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * track.clientWidth, behavior: 'smooth' });
    });
  });

  /* ---------- Real footage: load the animated clips only when they come into view ---------- */
  var clipIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var img = e.target; clipIO.unobserve(img);
      img.onload = function () { img.classList.add('is-loaded'); };
      img.src = img.dataset.src;
    });
  }, { rootMargin: '200px' }) : null;
  $$('.proof__clip[data-src]').forEach(function (img) {
    if (N.reducedMotion) return;
    if (clipIO) clipIO.observe(img); else { img.src = img.dataset.src; img.classList.add('is-loaded'); }
  });

  /* ---------- Hero product photo: tilts toward the cursor ---------- */
  var tilt = $('[data-tilt]');
  if (tilt && !N.reducedMotion && window.matchMedia('(pointer: fine)').matches) {
    var inner = $('.hero__product-inner', tilt), zone = tilt.closest('.hero') || document.body;
    zone.addEventListener('pointermove', function (e) {
      var r = zone.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - .5, py = (e.clientY - r.top) / r.height - .5;
      inner.style.setProperty('--rx', (px * 22).toFixed(2) + 'deg'); inner.style.setProperty('--ry', (-py * 18).toFixed(2) + 'deg');
    });
    zone.addEventListener('pointerleave', function () { inner.style.setProperty('--rx', '0deg'); inner.style.setProperty('--ry', '0deg'); });
  }

  /* ---------- FAQ: one open at a time ---------- */
  $$('[data-faq]').forEach(function (list) {
    list.addEventListener('toggle', function (e) {
      if (e.target.open) $$('details[open]', list).forEach(function (d) { if (d !== e.target) d.open = false; });
    }, true);
  });
})();
